import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">BIMS</h1>
        <p className="mt-2 text-muted-foreground">Barangay Information Management System</p>
        <p className="text-sm text-muted-foreground">Resident Portal</p>
      </div>
      <div className="flex gap-3">
        <Link to="/login">
          <Button variant="outline" size="lg">Sign In</Button>
        </Link>
        <Link to="/register">
          <Button size="lg">Register</Button>
        </Link>
      </div>
    </div>
  )
}
